<template>
  <page class="home-page">
    <zui-header style="margin-top: 15px;">
      <logo href="/"></logo>
         <drop-list :config="configData" ref="droplist"></drop-list>
        <zui-button><a href="#plan">招商联盟</a></zui-button>
        <zui-button><a href="#service">加入我们</a></zui-button>
         <zui-button><a href="#">首页</a></zui-button>
    </zui-header>
    <div class="banner vivify fadeIn"></div>
    <div class="service">
      <h3 id="service">
        星瑜家职培机构-自有的内部老师培养机制
      </h3>
    </div>
    <div class="disp01">
      <ul>
        <li>
          <img :src="feature1" width="410" height="210"/>
        </li>
        <li>
          <img :src="feature2" width="410" height="210"/>
        </li>
        <li>
          <img :src="feature3" width="410" height="210"/>
        </li>
     </ul>
      <ul>
        <li>
          <img :src="feature4" width="410" height="210"/>
        </li>
        <li>
          <img :src="feature5" width="410" height="210"/>
        </li>
        <li>
          <img :src="feature6" width="410" height="210"/>
        </li>
      </ul>
    </div>
    <div class="service">
      <h3 id="plan">
        如何加盟
      </h3>
    </div>
    <div style="text-align: center">
      <img :src="feature7" style="width: 100%;height: 683px;"/>
    </div>
    <div style="text-align: center">
      <h1 style='font-size: 50px;font-family:"微软雅黑", "Helvetica Neue", Helvetica, Arial, sans-serif;margin-bottom: 20px;margin-top: 20px;'>练瑜伽&nbsp;要到位</h1>
      <p class="weift">随约随上&nbsp;·&nbsp;一人也开班&nbsp;·&nbsp;双师教学</p>
      <img :src="feature8" style="margin-bottom: 20px;"/>
      <p class="gos">扫码星瑜家约课小程序</p>
      <p class="gos">快来门店和我们一起练习吧</p>
    </div>
    <zui-footer/>
  </page>
</template>
<script>
  import './less/home-page.less'
  import Logo from '../components/Logo'
  import Page from '../components/Page'
  import ZuiHeader from '../components/Header'
  import ZuiFooter from '../components/Footer'
  import ZuiButton from '../components/Button'
  import feature1 from '../assets/img/feature1.png'
  import feature2 from '../assets/img/feature2.png'
  import feature3 from '../assets/img/feature3.png'
  import feature4 from '../assets/img/feature4.png'
  import feature5 from '../assets/img/feature5.png'
  import feature6 from '../assets/img/feature6.png'
  import feature7 from '../assets/img/feature7.png'
  import feature8 from '../assets/img/feature8.png'
  import Util from '../Util'
  import DropList from 'vue-droplist'
  export default{
    components: {Page, Logo, ZuiHeader, ZuiFooter,ZuiButton,DropList},
    data () {
      return {
        feature1: feature1,
        feature2: feature2,
        feature3: feature3,
        feature4: feature4,
        feature5: feature5,
        feature6: feature6,
        feature7: feature7,
        feature8: feature8,
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2,
        configData : {
            position: {
              top: '60px',
              right: '15px',
              bottom: '',
              left: ''
            },
            width: '40%',
            list: [
              {text: '首页', action: this.gohome},
              {text: '加入我们', action: this.goservice},
              {text: '招商联盟', action: this.goplan}
            ]
        }
      }
    },
   methods: {
      onButtonClick: function (e) {
        if(e=="home"){
            this.$router.push({path:'/'})
        }else if(e=="service"){
            this.$router.push({path:'/service'})
        }else if(e=="plan"){
            this.$router.push({path:'/plan'})
        }else if(e=="case"){
            this.$router.push({path:'/case'})
        }else if(e=="link"){
            this.$router.push({path:'/link'})
        }else{
            this.$router.push({path:'/'})
        }
      },
      openMenu: function () {
       this.$refs.droplist.show()
      },
      gohome: function () {
       this.$router.push({path:'/'})
      },
      goservice: function () {
       this.$router.push({path:'/service'})
      },
      goplan: function () {
       this.$router.push({path:'/plan'})
      },
      gocase: function () {
       this.$router.push({path:'/case'})
      },
      golink: function () {
       this.$router.push({path:'/link'})
      },
    }

  }
</script>
<style scoped>
  .disp01{
    text-align: center;
  }
  .disp01 ul li{
    margin-left: 30px;
    margin-bottom: 20px;
    display:inline-block;
  }
  .weift{
    font-size: 16px;
    font-family: "微软雅黑", "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin-bottom: 20px;
  }
  .gos{
    margin-bottom: 5px;
    font-size: 16px;
    font-family: "微软雅黑", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue